import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { handleCopy } from "../../helpers";
import { IoCopySharp } from "react-icons/io5";

const Table = ({
  ApiData,
  openLogs,
}) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const goToProperties = (item) => {
    navigate(`/properties/${item.id}`, { state: { name: item?.name } });
  };
 

  useEffect(() => {
    if (ApiData) {
      const tempData = ApiData.map((item) => ({
        name: getName(item),
        mobile: item.mobile,
        city: getCity(item),
        propertyCount: propertyCount(item),
        tenantCount: getTenantCount(item),
        // action: ActionBtns(item),
        lastLogin: getLastLogin(item),
        createdAt: getCreatedAt(item),
      }));
      setData(tempData);
    }
  }, [ApiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

const getName = (item) => {
    return (
      <UserImageWrapper>
        <div className="flex flex-col">
          
          <p className="text-zinc-900 font-medium">
            {item.name}{" "}
            <span className="ml-1 inline-flex items-center justify-center text-[9px] px-[1.5px] font-semibold bg-blue-100 text-blue-700 rounded-full">{item.id}</span>
          </p>
          <div  className="flex items-center gap-1 text-xs text-gray-400">
            <p className="text-amber-500 text-xs">
              #{item.mobile}
            </p>
            <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopy(item.mobile);
                }}
                className="hover:text-gray-600 transition"
                title="Copy number"
              >
                <IoCopySharp size={8} />
            </button>
          </div>
        </div>
      </UserImageWrapper>
    );
  };

  const getCity = (item) => {
      const isLongCityName = item?.city?.length > 15;
      return (
        <div
          className="cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            openLogs(item);
          }}
                  >
          <div className="text-gray-500 font-medium text-sm">
            {item?.businessName}
          </div>
          <a
            data-tooltip-id={`tooltip-city-${item.id}`}
            data-tooltip-content={isLongCityName ? item.city : ""}
            data-tooltip-delay-show={1000}
            data-tooltip-place="top"
            data-tooltip-variant="info"
            className="max-w-[150px] text-gray-400 font-medium text-xs"
            href
          >
            {isLongCityName ? (
              <p className="cursor-pointer">
                {item.city.substring(0, 15) + "..."}
              </p>
            ) : (
              item.city || ""
            )}
          </a>
          <Tooltip id={`tooltip-city-${item.id}`} className="!w-60 sm:!w-80" />
        </div>
      );
    };

  const propertyCount = (item) => {
    const isClickable = item.propertyCount > 0;
    return (
      <div className="flex gap-3">
        <div className="flex flex-col ">
          <span
            className={`${
              isClickable
                ? "cursor-pointer underline font-semibold"
                : "cursor-default"
            }`}
            onClick={(e) => {
              e.stopPropagation();
              if (isClickable) goToProperties(item);
            }}
          >
            {"#" + item.propertyCount}
          </span>
          <span className="text-gray-400 font-medium text-xs">Properties</span>
        </div>
      </div>
    );
  };


  const getLastLogin = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <p className="text-gray-500 font-medium text-sm">{moment(item?.lastLogin).format("YYYY-MM-DD")}</p>
        <p className="text-gray-400 font-medium text-xs">{moment(item?.lastLogin).format("HH:mm:ss")}</p>
      </div>
    );
  };

  const getCreatedAt = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <p className="text-gray-500 font-medium text-sm">{moment(item?.createdAt).format("YYYY-MM-DD")}</p>
        <p className="text-gray-400 font-medium text-xs">{moment(item?.createdAt).format("HH:mm:ss")}</p>
      </div>
    );
  };

  const getTenantCount = (item) => {
  return (
    <div className="flex flex-col gap-[2px]">
      <div className="flex items-center">
        <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-700 font-semibold text-xs">
          {item?.tenantCount || 0}
        </span>
      </div>
      <p className="text-gray-400 font-medium text-xs">
        Active Tenants
      </p>
    </div>
  );
};


  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "Owner Name",
          accessor: "name",
        },
        {
        Header: "Tenant Count",
        accessor: "tenantCount",
      },
      ];
    }

    // Columns for larger screens
    return [
      {
        Header: "Owner Details",
        accessor: "name",
      },
      {
        Header: "City",
        accessor: "city",
      },
      {
        Header: "Property",
        accessor: "propertyCount",
      },
      {
        Header: "Tenant",
        accessor: "tenantCount",
      },
      {
        Header: "Last Used ",
        accessor: "lastLogin",
      },
      {
        Header: "Created At ",
        accessor: "createdAt",
      },
    //   {
    //     Header: "Action",
    //     accessor: "action",
    //   },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);
  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        {/* <Tbody {...getTableBodyProps()} hasdata={ApiData?.length > 0}> */}
        <Tbody
          {...getTableBodyProps()}
          className={ApiData?.length > 0 ? "border-b" : ""}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                {/* <Tr {...row.getRowProps()} hasdata={ApiData?.length > 0}> */}
                <Tr
                  {...row.getRowProps()}
                  className={ApiData?.length > 0 ? "border-b" : ""}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>City:</strong> {data[rowIndex].city}
                        </li>
                        <li>
                          <strong>Created At:</strong> {data[rowIndex].date}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status:</strong> {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75 "
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const UserImageWrapper = tw.div` flex items-center gap-2`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${({ hasdata }) => (hasdata ? "border-b" : "")}`;
const Tr = tw.tr`${({ hasdata }) =>
  hasdata ? "border-b" : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;

export default Table;
